import { useQuery } from "@tanstack/react-query";
import { memberStatus } from "./query";
import { PostModel } from "common/models/BaseModel";
import { IMemberStatusGridFilter } from "./types";

export function GetMemberStatuses(
  model: PostModel<IMemberStatusGridFilter> | undefined
) {
  return useQuery(memberStatus.list(model));
}

export function GetMemberStatus(Id: string | number | undefined) {
  return useQuery({
    ...memberStatus.getById(Id || ""),
    enabled: Boolean(Id),
  });
}

export function GetMemberStatusValues() {
  return useQuery({
    ...memberStatus.getMemberStatusValues(),
    refetchOnMount: true,
  });
}

export function GetMemberStatusView(id: string | number | undefined, isOpen: boolean) {
  return useQuery({
    ...memberStatus.getViewById(id),
    enabled: Boolean(id) && isOpen,
  });
}
